import { call, put } from 'redux-saga/effects';
import { getPersonalFields } from 'api/PersonalFields/getPersonalFields';
import { addSuspenseLists } from 'store/auto/store/ducks/suspenseLists';

export default function* loadSuspenseLists() {
  const suspenseListResponse = yield call(getPersonalFields);
  yield put(addSuspenseLists(suspenseListResponse));
}
